import { __rest } from 'tslib';
import { dispatchViewEvent } from '../utils/events.es.js';
import { inView as inView$1 } from '../../gestures/in-view.es.js';
var inView = {
  isActive: function isActive(options) {
    return Boolean(options.inView);
  },
  subscribe: function subscribe(element, _ref, _ref2) {
    var enable = _ref.enable,
      disable = _ref.disable;
    var _ref2$inViewOptions = _ref2.inViewOptions,
      inViewOptions = _ref2$inViewOptions === void 0 ? {} : _ref2$inViewOptions;
    var once = inViewOptions.once,
      viewOptions = __rest(inViewOptions, ["once"]);
    return inView$1(element, function (enterEntry) {
      enable();
      dispatchViewEvent(element, "viewenter", enterEntry);
      if (!once) {
        return function (leaveEntry) {
          disable();
          dispatchViewEvent(element, "viewleave", leaveEntry);
        };
      }
    }, viewOptions);
  }
};
export { inView };